<!-- Zeigt die Felder des Reiters, der rechts auf der Chat-Styling-Seite
     gewählt ist ([section]: „window“ = Chat-Fenster, „bubble“ = Chat-Blase).
     Alle Felder bleiben in einer FormGroup, damit Speichern und das
     Mitwandern der Pop-up-Farben unverändert bleiben. -->
<form [formGroup]="form" class="grid">
  <ng-container *ngFor="let setting of visibleSettings">
  <div class="group" [class.group--aid]="setting.type === 'aid-color'">
    <label for="{{ setting?.name }}" class="label col-form-label">{{
      labelOf(setting)
    }}</label>

    @if(descriptionOf(setting)){

    <nb-icon
      icon="question-mark-circle-outline"
      [nbPopover]="descriptionOf(setting) ?? ''"
      nbPopoverTrigger="hover"
      nbPopoverPlacement="bottom"
    ></nb-icon>
    }@else {
    <div></div>
    }

    <input
      *ngIf="setting.type === 'text'"
      type="text"
      nbInput
      fullWidth
      id="{{ setting?.name }}"
      [formControl]="control(setting.name)"
      placeholder="{{ setting?.placeholder }}"
    />

    <div class="upload-wrap" *ngIf="setting.type === 'image-upload'">
      <app-image-upload
        [fieldName]="setting.name"
        [square]="false"
        [uploadLabel]="'pages.chatStyling.form.logo.uploadButton' | translate"
        [uploadingLabel]="'pages.chatStyling.form.logo.uploading' | translate"
        [formControl]="control(setting.name)"
      ></app-image-upload>
      <p class="upload-hint" *ngIf="hintOf(setting) as hint">{{ hint }}</p>
    </div>

    <div class="autocomplete-wrapper" *ngIf="setting.type === 'autocomplete'">
      <input
        type="text"
        nbInput
        fullWidth
        id="{{ setting?.name }}"
        [formControl]="control(setting.name)"
        placeholder="{{ setting?.placeholder }}"
        [nbAutocomplete]="auto"
      />
      <nb-autocomplete #auto>
        <nb-option
          *ngFor="let option of filteredOptionsMap[setting.name] | async"
          [value]="option"
        >
          {{ option }}
        </nb-option>
      </nb-autocomplete>
    </div>

    <app-color-input
      *ngIf="setting.type === 'color'"
      id="{{ setting?.name }}"
      [allowGradient]="!!setting.allowGradient"
      [formControl]="control(setting.name)"
    ></app-color-input>

    <nb-toggle
      *ngIf="setting?.type === 'boolean'"
      [formControl]="control(setting.name)"
    ></nb-toggle>

    <div class="range-wrapper" *ngIf="setting.type === 'range'">
      <input
        type="range"
        class="range-input"
        [min]="setting.min ?? 16"
        [max]="rangeMax(setting)"
        [step]="setting.step ?? 2"
        [formControl]="control(setting.name)"
      />
      <span class="range-value">{{ form.get(setting.name)?.value }}{{ setting.unit ?? 'px' }}</span>
    </div>

    <nb-select
      *ngIf="setting?.type === 'select'"
      fullWidth
      [formControl]="control(setting.name)"
      placeholder="{{ setting?.placeholder }}"
    >
      <nb-option *ngFor="let v of optionsOf(setting)" [value]="v.value">{{
        v.label
      }}</nb-option>
    </nb-select>

    <!-- Farbe der Lernhilfen: angezeigt wird der abgeleitete bzw.
         gesetzte Wert (Stellvertreter-Feld); erst eine Eingabe setzt ihn fest. -->
    <app-color-input
      *ngIf="setting.type === 'aid-color'"
      id="{{ setting?.name }}"
      [allowGradient]="!!setting.allowGradient"
      [formControl]="aidProxy[setting.name]"
    ></app-color-input>

    <div class="aid-state" *ngIf="setting.type === 'aid-color'">
      @if (isAidAuto(setting.name)) {
        <span class="aid-auto" [nbTooltip]="'pages.chatStyling.form.aid.autoHint' | translate">
          {{ 'pages.chatStyling.form.aid.auto' | translate }}
        </span>
      } @else {
        <button type="button" class="aid-reset" (click)="resetAid(setting.name)"
                [nbTooltip]="'pages.chatStyling.form.aid.resetHint' | translate">
          <nb-icon icon="refresh-outline"></nb-icon>{{ 'pages.chatStyling.form.aid.reset' | translate }}
        </button>
      }
      @if (aidIssueText(setting.name); as warning) {
        <span class="aid-warning"><nb-icon icon="alert-triangle-outline"></nb-icon>{{ warning }}</span>
      }
    </div>
  </div>
  </ng-container>
</form>
